export default (superClass) => {
    return class extends superClass {
            
            get hasTrustpilotData() {
                return Boolean(this.trustpilotUrl);
            }   

            get trustpilotUrl() {
                return this._data.trustpilot_url;
            }

            get trustpilotScore() {
                return this._data.trustpilot_average_score;
            }
            
            get trustpilotRatingCount() {
                return this._data.trustpilot_rating_count;
            }

            get trustpilotData() {
                if (! this.hasTrustpilotData) {
                    return null;
                }

                return {
                    url: this.trustpilotUrl,
                    score: this.trustpilotScore,
                    ratingCount: this.trustpilotRatingCount,
                }
            }
    }
}